import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const store = new Vuex.Store({
	state:{
		user:{
			name:'',
			token:''
		},
		messageArr:[]
	},
	//同步操作
	mutations:{
		updateUser(state,playod){
			this.state.user = playod;
		},
		updateMessage(state,playod){
			this.state.messageArr.push(playod);
		}
	},
	//异步操作
	actions:{
		asyncUpdateUser(state,playod){
			this.state.user = playod;
		}
	},
	//获取
	getters:{
		//获取登录账户
		getUserName(state){
			return state.user.name;
		},
		getMessage(state){
			return state.user.messageArr;
		}
	}
})

export default store;



// WEBPACK FOOTER //
// ./src/vuex/store.js